import React, { useState } from "react";
const CustomInput = ({
  type = "text",
  placeholder = "",
  value = "",
  onChange = () => {},
  className = "",
  wrapperClassName = "",
  label = "",
  wrapperStyle = {},
  mandatory = false, // Add mandatory prop
  minLength = 6, // For password validation
  maxLength = 100, // For text-based inputs
  pattern, // For custom pattern validation (e.g., regex)
  ...props
}) => {
  const [error, setError] = useState("");

  // Function to validate email
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  // Function to validate password
  const validatePassword = (password) => {
    // Password must be at least 6 characters long
    return password.length >= minLength;
  };

  // Function to validate number
  const validateNumber = (number) => {
    return !isNaN(number);
  };

  const validateRequired = (value) => {
    return mandatory ? value.trim() !== "" : true;
  };

  // Function to handle custom regex validation (if provided)
  const validatePattern = (value) => {
    if (pattern) {
      return pattern.test(value);
    }
    return true;
  };

  // Handle input change with validation
  const handleChange = (e) => {
    const { value } = e.target;
    onChange(e); // Call parent onChange

    let isValid = true;
    let validationError = "";

    // Perform validation based on input type
    if (type === "email" && !validateEmail(value)) {
      isValid = false;
      validationError = "Please enter a valid email address";
    } else if (type === "password" && !validatePassword(value)) {
      isValid = false;
      validationError = `Password must be at least ${minLength} characters long`;
    } else if (type === "number" && !validateNumber(value)) {
      isValid = false;
      validationError = "Please enter a valid number";
    } else if (!validateRequired(value)) {
      isValid = false;
      validationError = "This field is required";
    } else if (!validatePattern(value)) {
      isValid = false;
      validationError = "Invalid input format";
    }

    // Set the error message if validation fails
    if (!isValid) {
      setError(validationError);
    } else {
      setError("");
    }
  };

  return (
    <div
      style={wrapperStyle}
      className={`flex flex-col space-y-2 ${wrapperClassName}`}
    >
      {label && (
        <label className="text-sm font-semibold text-gray-700">
          {label}
          {/* Conditionally render the asterisk for mandatory fields */}
          {mandatory && <span className="text-red-500  ml-2">*</span>}
        </label>
      )}

      {/* Input Field */}
      <input
        type={type}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={` h-10 border ${
          error ? "border-red-500" : "border-gray-300"
        }  border-2 rounded-sm p-2 disabled:bg-slate-100 disabled:cursor-not-allowed text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-gray-500 ${className}`}
        {...props}
      />

      {/* Show error message if validation fails */}
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default CustomInput;
